<div fxLayout="row" fxLayoutAlign="center" ngClass="p-b-xxl m-b-xl p-t-l">
	<div
		fxLayout="column"
		class="dark-grey-texts"
		fxFlex.gt-lg="75%"
		fxFlex.gt-xs="100%"
		fxFlex.xs="90%"
	>
		<div
			fxLayout="row"
			fxLayoutAlign="center"
			ngClass.gt-sm="p-b-xl"
			ngClass.lt-md="p-b-l"
		>
			<h2
				class="text-align-center"
				i18n="@@homepage_organisation_fundraiserForGlobal_heading"
			>
				Fundraiser for Global
			</h2>
		</div>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxFlex="100%"
			fxLayoutAlign="center"
			fxLayoutGap="3%"
		>
			<div fxLayout="column" fxFlex.gt-sm="32%" fxFlex.sm="40%">
				<img
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/homepageOrganisationSite/public"
				/>
			</div>
			<div
				fxLayout="column"
				fxFlex.sm="45%"
				fxFlex.md="40%"
				fxFlex.lg="32%"
				fxLayoutAlign="center"
				fxLayoutGap="5%"
			>
				<div fxLayout="column">
					<div fxLayout="row">
						<mat-card-title
							i18n="@@homepage_organisation_fundraiserForGlobal_multiCurrency"
							>Multi Currency</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="inc-span-height"
							i18n="
								@@homepage_organisation_fundraiserForGlobal_multiCurrencyContent"
						>
							You can use the WhyDonate platform or integrate the recurring
							giving form on your own website.
						</p>
					</div>
				</div>
				<div fxLayout="column">
					<div fxLayout="row">
						<mat-card-title
							i18n="@@homepage_organisation_fundraiserForGlobal_multiPayment"
							>Multiple Payment Methods</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="inc-span-height"
							i18n="
								@@homepage_organisation_fundraiserForGlobal_multiPaymentContent"
						>
							Take recurring donations via credit cards, PayPal, Sofort, iDeal,
							Bancontact, Giropay or SEPA Bank Transfers.
						</p>
					</div>
				</div>
				<div fxLayout="column">
					<div fxLayout="row">
						<mat-card-title
							i18n="@@homepage_organisation_fundraiserForGlobal_multiLanguage"
							>Multiple Languages</mat-card-title
						>
					</div>
					<div fxLayout="row">
						<p
							class="inc-span-height"
							i18n="
								@@homepage_organisation_fundraiserForGlobal_multiLanguageContent"
						>
							Users can create their own crowdfunding page on your platform and
							manage it by placing text, video and images.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
